import React, { useState, useEffect } from 'react';
import { SimpleView, GridView, FilterWidget, Widget, FormSelect, FormInput, Table, CompositeView } from '@digital/ui';
import {
  searchValues,
  RelatorioStatusCorrespondencias,
  CorrespondenciaFilter,
  relatorioExportExcel,
} from './@app/../../../api/relatorioStatusCorrespondencias';
import { ColumnProps } from 'antd/lib/table';
import { ExcelButton, SearchButton } from '@app/components/FormButtons';
import { getAllFornecedoresOptions } from '@app/api/fornecedor';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { FormSelectFilter } from '@app/components/FormSelectFilter';

const RelatorioStatusCorrespondencias = () => {
  const [items, setItems] = useState<RelatorioStatusCorrespondencias[]>();
  const [getList, setGetList] = useState<boolean>(true);

  const columnCorrespondencia: ColumnProps<any>[] = [
    {
      title: 'Contrato',
      dataIndex: 'numeroContrato',
      width: '5%',
    },
    {
      title: 'Nome Fornecedor',
      dataIndex: 'fornecedor',
      width: '20%',
    },
    {
      title: 'Número Controle',
      dataIndex: 'codigo',
      width: '15%',
    },
    {
      title: 'Assunto',
      dataIndex: 'assunto',
      width: '35%',
    },
    {
      title: 'Data Envio',
      dataIndex: 'dataEnvio',
      width: '10%',
    },
    {
      title: 'Prazo Resposta',
      dataIndex: 'prazoResposta',
      width: '10%',
    },
  ];

  useEffect(() => {
    var obj = {} as CorrespondenciaFilter;
    handleFilter(obj);
  }, [getList]);

  const handleFilter = (values: CorrespondenciaFilter) => {
    searchValues(values).then(resp => resp && setItems(resp));
  };

  const handleExcel = async (values: CorrespondenciaFilter) => {
    relatorioExportExcel(values);
  };

  return (
    <CompositeView>
      <SimpleView>
        <GridView>
          <FilterWidget
            active={[]}
            actions={[
              <ExcelButton type="link" key="excelBtn" onClick={handleExcel} />,
              <SearchButton type="primary" key="filterBtn" onClick={handleFilter} />,
            ]}
            title="Filtros">
            <FormInput label="Contrato" name="numeroContrato" span={4} />
            <FormSelectFilter
              label="Fornecedor"
              name="fornecedoresId"
              span={4}
              dataOptions={() => getAllFornecedoresOptions()}
            />
          </FilterWidget>
          <Widget title="Relatório de Status de Correspondências">
            <PerfectScrollbar>
              <Table columns={columnCorrespondencia} dataSource={items || []} pagination={{ pageSize: 100 }} />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default RelatorioStatusCorrespondencias;
